/// <amd-module name="Analytics/Shared/Common/Utils/Telemetry" />
import { ContextType, IReportContext } from "Analytics/Shared/Common/Types";
import * as Utils_String from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";

export function publishEvent(
    pageContext: IVssPageContext,
    area: string,
    feature: string,
    reportContext: IReportContext,
    properties: { [key: string]: any }
) {
    try {
        const telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        const definitionIdType: string = ContextType[reportContext.contextType];
        properties[definitionIdType] = reportContext.definitionId;
        telemetryService.publishEvent(area, feature, properties);
    } catch (e) {
        console.error(Utils_String.format("[TelemetryService.logProperties]: Error in logging Customer Intelligence data. Error: {0}", e.message));
    }
}
